import { sagas as ofacSagas } from '../features/Ofac/store/sagas'
export const sagas = [...ofacSagas]
